"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementName = void 0;
exports.instanceOfRequirementName = instanceOfRequirementName;
exports.RequirementNameFromJSON = RequirementNameFromJSON;
exports.RequirementNameFromJSONTyped = RequirementNameFromJSONTyped;
exports.RequirementNameToJSON = RequirementNameToJSON;
exports.RequirementNameToJSONTyped = RequirementNameToJSONTyped;
/**
 *
 * @export
 */
exports.RequirementName = {
    Availability: 'availability',
    PersonalInformation: 'personalInformation',
    Certifications: 'certifications',
    Licenses: 'licenses',
    Vaccinations: 'vaccinations',
    RegulatoryAssessments: 'regulatoryAssessments',
    Tuberculosis: 'tuberculosis',
    GeneralBackgroundCheck: 'generalBackgroundCheck',
    DhsBackgroundCheck: 'dhsBackgroundCheck',
    ConfidentialityAgreement: 'confidentialityAgreement',
    Contract: 'contract',
    Payroll: 'payroll',
    Specialties: 'specialties',
    Resume: 'resume',
    FitTesting: 'fitTesting',
    EmrSystems: 'emrSystems',
    FacilityVerifications: 'facilityVerifications',
    Blocked: 'blocked',
    StatePracticeAuthorization: 'statePracticeAuthorization'
};
function instanceOfRequirementName(value) {
    for (const key in exports.RequirementName) {
        if (Object.prototype.hasOwnProperty.call(exports.RequirementName, key)) {
            if (exports.RequirementName[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function RequirementNameFromJSON(json) {
    return RequirementNameFromJSONTyped(json, false);
}
function RequirementNameFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RequirementNameToJSON(value) {
    return value;
}
function RequirementNameToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=RequirementName.js.map